import { useSelector } from "@tanstack/react-store"
import { bottomPopupStore } from "./store"
import type { PopupContentType } from "./types"

export function usePopup(): PopupContentType | null {
	return useSelector(bottomPopupStore, (state) => state.currentPopup)
}

/** true — попап активен и не в exit-фазе (значение для OverlayHost.open). */
export function usePopupOpen(): boolean {
	return useSelector(
		bottomPopupStore,
		(state) => state.currentPopup !== null && !state.closing,
	)
}
